import {useQueries} from "@tanstack/react-query";
import AttendanceSequenceService from "../../../../services/reports/attendance-sequence-service.js";

const UseFetchOptions = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['dispatch-natures'],
                queryFn: () => AttendanceSequenceService.dispatchNatures().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
            {
                queryKey: ['dispatch-nature-groups'],
                queryFn: () => AttendanceSequenceService.dispatchNatureGroups().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
            {
                queryKey: ['channel-names'],
                queryFn: () => AttendanceSequenceService.channelNames().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
            {
                queryKey: ['street-names'],
                queryFn: () => AttendanceSequenceService.streetNames().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
            {
                queryKey: ['place-names'],
                queryFn: () => AttendanceSequenceService.placeNames().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
            {
                queryKey: ['neighborhood'],
                queryFn: () => AttendanceSequenceService.neighborhood().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
            {
                queryKey: ['all-sector'],
                queryFn: () => AttendanceSequenceService.allSector().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text }))),
                initialData: [],
            },
        ]
    });

    return {
        dispatchNaturesOptions: queries[0].data,
        dispatchNaturesGroupsOptions: queries[1].data,
        channelNamesOptions: queries[2].data,
        streetNamesOptions: queries[3].data,
        placeNamesOptions: queries[4].data,
        neighborhoodOptions: queries[5].data,
        allSectorOptions: queries[6].data,
    };
};

export default UseFetchOptions;